import { Stack, Box, Chip } from "@mui/material";
import { useSyncExternalStore } from "react";

function subscribe(callback: () => void) {
  window.addEventListener("online", callback);
  window.addEventListener("offline", callback);
  return () => {
    window.removeEventListener("online", callback);
    window.removeEventListener("offline", callback);
  };
}

function getSnapshot() {
  return navigator.onLine;
}

function getServerSnapshot() {
  return true;
}

export default function InternetCheckingHeader() {
  const isOnline = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        px: 3,
        py: 2,
        borderRadius: 2,
        paddingRight: "0px !important"
      }}
    >
      {/* RIGHT STATUS */}
      <Chip
        icon={
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              bgcolor: isOnline ? "#00AB55" : "#ff4d4f",
            }}
          />
        }
        label={isOnline ? "SYSTEM ONLINE" : "SYSTEM OFFLINE"}
        sx={{
          bgcolor: "white",
          color: isOnline ? "#00AB55" : "#ff4d4f",
          border: { xs: 'none', md: `1px solid ${isOnline ? "#00AB55" : "#ff4d4f"}` },
          fontWeight: 600,
          px: { xs: 0, md: 1.5 },
          minWidth: { xs: 32, md: 'auto' },
          height: 32,
          '& .MuiChip-label': {
            display: { xs: 'none', md: 'block' }
          }
        }}
      />
    </Stack>
  );
}
